import { Radio } from "@headlessui/react";
import { ComponentPropsWithoutRef } from "react";
import cn from "../util/cn";

type RadioButtonProps = ComponentPropsWithoutRef<typeof Radio>;

const RadioButton = ({ disabled, children, className, ...otherProps }: RadioButtonProps) => (
  <Radio
    disabled={disabled}
    className={cn(
      "cursor-pointer select-none rounded-md bg-primary/10 px-4 py-2 font-semibold text-primary/90 shadow-sm transition duration-200",
      "focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary data-[focus]:outline-1 data-[focus]:outline-primary",
      "data-[checked]:bg-primary data-[checked]:text-white",
      "data-[disabled]:cursor-not-allowed data-[disabled]:opacity-40",
      !disabled && "hover:bg-primary/20",
      className
    )}
    {...otherProps}
  >
    {children}
  </Radio>
);

export default RadioButton;
